/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantUpdateResponse {
    getFixupPrototypeFunction() { return TenantUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<TenantUpdateResponse>): TenantUpdateResponse {
        let obj = Object.assign(new TenantUpdateResponse(), model);
        TenantUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantUpdateResponse>): TenantUpdateResponse {
        if (!model) return null;
        return TenantUpdateResponse.newInstance(<TenantUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantUpdateResponse) {
        if (!obj) return;

        models.TenantUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantUpdateResponse): boolean {
        Object.setPrototypeOf(obj, TenantUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the updated tenant. This Id will be used for performing tenant level operations such as createPolicy, createScript, onboardCloudAccount and so on.
     */
    tenant_id: string;

}
